import Explanation from './Explanation'

export default Explanation
